import { render } from "./CreateTraining.vue?vue&type=template&id=45048d70&scoped=true"
import script from "./CreateTraining.vue?vue&type=script&lang=js"
export * from "./CreateTraining.vue?vue&type=script&lang=js"

import "@suadelabs/vue3-multiselect/dist/vue3-multiselect.css?vue&type=style&index=0&lang=css"
import "./CreateTraining.vue?vue&type=style&index=1&id=45048d70&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/1-fbk-tabor/1-fbk-tabor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45048d70"]])

export default __exports__